import React from 'react';
import { FormControl, Select, MenuItem, InputLabel, Box, CircularProgress } from '@mui/material';
import StoreIcon from '@mui/icons-material/Store';
import { useTranslate } from 'react-admin';
import { useBranch } from '../context/BranchContext';

export const BranchSelector: React.FC = () => {
  const { branches, selectedBranchId, setSelectedBranchId, isLoading } = useBranch();
  const translate = useTranslate();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', mx: 2 }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (branches.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mx: 2, minWidth: 200 }}>
      <StoreIcon sx={{ mr: 1, color: 'white' }} />
      <Box sx={{ mr: 1, color: 'white', fontWeight: 500, whiteSpace: 'nowrap' }}>
        {translate('app.branch')}:
      </Box>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel id="branch-label" sx={{ display: 'none' }}>{translate('app.branch')}</InputLabel>
        <Select
          labelId="branch-label"
          value={selectedBranchId || 'all'}
          onChange={(e) => setSelectedBranchId(e.target.value === 'all' ? null : e.target.value as string)}
          sx={{
            color: 'white',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.5)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white',
            },
            '.MuiSvgIcon-root': {
              color: 'white',
            },
          }}
        >
          <MenuItem value="all">{translate('app.allBranches')}</MenuItem>
          {branches.map((branch) => (
            <MenuItem key={branch.id} value={branch.id}>
              {branch.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
